import Nullstack from 'nullstack';
export default function IconBike({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-bike",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "18",
    r: "3"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "18",
    r: "3"
  }), "   ", Nullstack.element("polyline", {
    points: "12 19 12 15 9 12 14 8 16 11 19 11"
  }), "   ", Nullstack.element("circle", {
    cx: "17",
    cy: "5",
    r: "1"
  }), " ");
}